<div class="popup">
  <div class="header">
    <div class="tt">
      <img src="assets/temp5/bottom-icon-race.png" alt="" />
      <span>{{ 'rank_jop' | translate }}</span>
    </div>
    <div class="btn-close" (click)="close()">
      <i class="icon-error"></i>
    </div>
  </div>
  <div>
    <div class="menu">
      <ng-container *ngIf="topList.length > 0">
        <mat-tab-group
          mat-stretch-tabs
          [selectedIndex]="selectedActivitIndex"
          (selectedIndexChange)="onSelectAcivity($event)"
          [disablePagination]="false"
        >
          <mat-tab [label]="item.title" *ngFor="let item of topList; let i = index"></mat-tab>
        </mat-tab-group>
      </ng-container>
    </div>
  </div>

  <div class="content" [appLoading]="rankLoading">
    <ng-container *ngIf="rankList.length > 0">
      <table>
        <thead>
          <tr>
            <th *ngFor="let item of selectTitleData; let index = index">
              <ng-container *ngIf="item.icon">
                <app-tool-tip class="inline-block">
                  <i origin [class]="item.icon" class="mutual-opacity"></i>
                  <p tooltip>{{ item.toolTips }}</p>
                </app-tool-tip>
                <span class="ml-6">{{ item.text }}</span>
              </ng-container>
              <ng-container *ngIf="!item.icon">
                {{ item.text }}
              </ng-container>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="mutual-opacity" *ngFor="let item of rankList">
            <td>
              <ng-container *ngIf="item?.rankNumber < 4">
                <img
                  class="badge"
                  [src]="'assets/images/daily-races/' + (item?.rankNumber || 0) + '.svg'"
                  lazy="loading"
                  alt=""
                />
              </ng-container>
              <ng-container *ngIf="item?.rankNumber >= 4">
                <p>{{ item?.rankNumber || 0 }}th</p>
              </ng-container>
            </td>
            <td class="">
              <div class="players">
                <img class="avatar" [src]="item.avatar | avatarDefault" lazy="loading" alt="" />
                <p class="inline-block ml-6">
                  {{ item?.userName || item?.uid || '' }}
                </p>
              </div>
            </td>
            <td class="">
              <ng-container *ngIf="selectedType == 2; else amountType">
                <p class="text-12 gray-color">{{ item?.rankMoney }}x</p>
              </ng-container>
              <ng-template #amountType>
                <p class="text-12 gray-color inline-block">
                  {{ item?.rankMoney || 0 | currencyValue: 'USDT' }}
                </p>
                <img class="ml-6" [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
              </ng-template>
            </td>
            <td class="">
              <p class="green-color inline-block">{{ item?.bonusUsdtMoney || 0 | currencyValue: 'USDT' }}</p>
              <img class="ml-6" [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <app-empty class="mt-auto" *ngIf="rankList.length === 0 && !rankLoading"></app-empty>
  </div>

  <div class="page">
    <app-paginator
      *ngIf="rankList.length > 0"
      [(page)]="paginator.page"
      [total]="paginator.total"
      [pageSize]="paginator.pageSize"
      [disabled]="rankLoading"
      [loading]="rankLoading"
      [alwaysWeb]="true"
      (onPageChange)="getRank()"
    >
    </app-paginator>
  </div>
</div>
